module.exports = __webpack_public_path__ + "img/20210930.60c5bd33.png";